const messages = {
    title: 'head.title',
    titleDesc: 'head.title.desc',
};
export default messages;
//# sourceMappingURL=messages.js.map